import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg sticky-top px-2 px-md-5" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  class: "navbar-brand",
  href: "./"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#navbarOffcanvasLg",
  "aria-controls": "navbarOffcanvasLg"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_7 = {
  class: "offcanvas offcanvas-end mw-75",
  tabindex: "-1",
  id: "navbarOffcanvasLg",
  "aria-labelledby": "navbarOffcanvasLgLabel"
}
const _hoisted_8 = { class: "offcanvas-header bg-color1 justify-content-center" }
const _hoisted_9 = {
  class: "offcanvas-title p-5",
  href: "#",
  id: "navbarOffcanvasLgLabel"
}
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "offcanvas-body" }
const _hoisted_12 = { class: "navbar-nav justify-content-end flex-grow-1 pe-3" }
const _hoisted_13 = { class: "nav-item text-center p-2 border-bottom border-bottom-md-0 border-color1" }
const _hoisted_14 = { class: "nav-item text-center p-2 border-bottom border-bottom-md-0 border-color1" }
const _hoisted_15 = { class: "nav-item text-center p-2 border-bottom border-bottom-md-0 border-color1" }
const _hoisted_16 = { class: "nav-item text-center p-2 border-bottom border-bottom-md-0 border-color1" }
const _hoisted_17 = { class: "nav-item text-center p-2 border-bottom border-bottom-md-0 border-color1" }
const _hoisted_18 = { class: "nav-item text-center p-2 border-bottom border-bottom-md-0 border-color1" }

import { ref, onMounted } from 'vue';
import { useConfigStore, useGlobalStore } from '@/stores';
import TopBar from '@/components/TopBar.vue';
import { OrganizationType } from '@/composables/types';
import logo from '@/assets/logo.png';
import logoWhite from '@/assets/logo-white.png';

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const configStore = useConfigStore();
const globalStore = useGlobalStore();

const organization = ref<OrganizationType | undefined>(undefined);

onMounted(() => {
  if (globalStore.organization.nameAr == null) {
    globalStore.fetchOrganization();
  }
  organization.value = globalStore.organization;
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopBar),
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createElementVNode("img", {
            class: "colored-brand",
            src: _unref(logo),
            alt: 
            organization.value
              ? _unref(configStore).stringLang(organization.value.nameAr, organization.value.nameEn)
              : ''
          ,
            height: "65"
          }, null, 8, _hoisted_4),
          _createElementVNode("img", {
            class: "white-brand hidden",
            src: _unref(logoWhite),
            alt: 
            organization.value
              ? _unref(configStore).stringLang(organization.value.nameAr, organization.value.nameEn)
              : ''
          ,
            height: "65",
            style: {"display":"none"}
          }, null, 8, _hoisted_5)
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", _hoisted_9, [
              _createElementVNode("img", {
                class: "mw-100 mh-100",
                src: _unref(logoWhite),
                alt: 
                organization.value
                  ? _unref(configStore).stringLang(
                      organization.value.nameAr,
                      organization.value.nameEn
                    )
                  : ''
              
              }, null, 8, _hoisted_10)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", _hoisted_13, [
                _createElementVNode("a", {
                  class: "nav-link",
                  onClick: _cache[0] || (_cache[0] = 
                  () => {
                    _ctx.$router.push({ name: 'homePage' });
                  }
                )
                }, _toDisplayString(_ctx.$t('HOME_PAGE')), 1)
              ]),
              _createElementVNode("li", _hoisted_14, [
                _createVNode(_component_v_menu, { "offset-y": "" }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({ variant: "plain" }, props, {
                      text: _ctx.$t('ABOUT_US'),
                      "prepend-icon": "mdi-chevron-down"
                    }), null, 16, ["text"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('OUR_STRATEGIC'),
                          to: { name: 'aboutPage' }
                        }, null, 8, ["title"]),
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('ABOUT_ORGANIZATION'),
                          to: { name: 'aboutPage' }
                        }, null, 8, ["title"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalStore).teams, (team, index) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: index,
                            title: _unref(configStore).stringLang(team.nameAr, team.nameEn),
                            to: { name: 'teamPage', params: { id: team.id as number | string } }
                          }, null, 8, ["title", "to"]))
                        }), 128)),
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('OUR_PARTNERS'),
                          to: { name: 'partnersPage' }
                        }, null, 8, ["title"]),
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('CONTACT_US'),
                          to: { name: 'contactUsPage' }
                        }, null, 8, ["title"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("a", {
                  class: "nav-link",
                  onClick: _cache[1] || (_cache[1] = 
                  () => {
                    _ctx.$router.push({ name: 'governancesPage' });
                  }
                )
                }, _toDisplayString(_ctx.$t('GOVERNANCES')), 1)
              ]),
              _createElementVNode("li", _hoisted_16, [
                _createVNode(_component_v_menu, { "offset-y": "" }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({ variant: "plain" }, props, {
                      text: _ctx.$t('PRODUCT_AND_PROJECT'),
                      "prepend-icon": "mdi-chevron-down"
                    }), null, 16, ["text"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('OUR_PROJECTS'),
                          to: { name: 'projectsPage' }
                        }, null, 8, ["title"]),
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('OUR_PRODUCTS'),
                          to: { name: 'postsList', params: { type: 'products' } }
                        }, null, 8, ["title"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_17, [
                _createVNode(_component_v_menu, { "offset-y": "" }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({ variant: "plain" }, props, {
                      text: _ctx.$t('MEDIA_WINDOW'),
                      "prepend-icon": "mdi-chevron-down"
                    }), null, 16, ["text"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('NEWS'),
                          to: { name: 'postsList', params: { type: 'news' } }
                        }, null, 8, ["title"]),
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('EVENTS'),
                          to: { name: 'postsList', params: { type: 'events' } }
                        }, null, 8, ["title"]),
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('ARTICALS'),
                          to: { name: 'postsList', params: { type: 'articals' } }
                        }, null, 8, ["title"]),
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('REPORTS'),
                          to: { name: 'reportsPage' }
                        }, null, 8, ["title"]),
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('ALBUMS'),
                          to: { name: 'albumsPage' }
                        }, null, 8, ["title"]),
                        _createVNode(_component_v_list_item, {
                          title: _ctx.$t('IDENTITIES'),
                          to: { name: 'identitiesPage' }
                        }, null, 8, ["title"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_18, [
                _createElementVNode("a", {
                  class: "nav-link",
                  style: {"color":"#8b277d"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
                  _unref(configStore).setLocale(
                    _unref(configStore).locale === 'en' ? 'ar' : 'en'
                  )
                ))
                }, _toDisplayString(_unref(configStore).locale === 'en' ? 'عربي' : 'English'), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})